<template>
    <div class="search-main-box">
		<SearchCondition
		    ref="searchConditon"
		    :conditionFields="conditionFields"
        :isShowLeftModel="false"
		    :class="'search-field-box-new'"
		    :style="'height:60vh;overflow:auto;'"
		    :key="loadtimeSearch"
		    >
		</SearchCondition>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import {getModelFormReportList, getFormFieldListByIds} from '@/data-model';
import SearchConditionSide from '@/components/SearchCondition/SearchConditionSide';
export default{
    components: {
        SearchConditionSide: SearchConditionSide
    },
    props: {
        moduleSearchObj: {
            type: Object
        }
    },
    data () {
        return {
            conditionFields: [],
            loadtimeSearch: '',
            searchParams: {
                modelId: '',
                name: '',
                selectedFields: '',
                searchCondition: [],
                selectedApprovalStatus: '',
                formId: ''
            },
            formPage: {
                currentPage: 1, // 当前页码
                pageSize: 3, // 每页条数
                totalPageNum: 0 // 总页数
            }
        };
    },
    created () {
        if (!this.moduleSearchObj.conditionFields || this.moduleSearchObj.conditionFields.length < 5) {
            let param = {dataModelId: this.moduleSearchObj.dataModelId, dataFormId: this.moduleSearchObj.dataFormId};
            this.renderFormList(param, true);
        } else {
            let search = cloneDeep(this.moduleSearchObj.conditionFields);
            if (typeof (search) === 'string') {
                let cfs = JSON.parse(search);
                this.conditionFields = JSON.parse(cfs);
            } else if (typeof (search) === 'object') {
                this.conditionFields = search;
            }
        }
    },
    methods: {
        async renderFormList (model, isInitSearch) {
            this.searchParams.searchCondition = [];
            this.searchParams.modelId = model.dataModelId;
            this.searchParams.formId = model.dataFormId;
            this.searchParams.modelType = model.modeType;
            this.searchParams.isFilterDuplicateData = false;
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let formData = await getModelFormReportList(Object.assign({}, {
                currentPage: this.formPage.currentPage,
                pageSize: this.formPage.pageSize
            }, this.searchParams));
            let tcln = [];
            if (formData.otherData && formData.otherData.tableColumns) {
                let _tableColumns = formData.otherData.tableColumns;
                _tableColumns.forEach(item => {
                    if (item.type !== 'divider') { // 隐藏分割线
                        tcln.push(item);
                    }
                });
            }
            this.refreshSearchConditon(tcln);
            loading.close();
        },
        async refreshSearchConditon (columns) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let rtArr = [];
            let idArr = [];
            columns.forEach(item => {
                idArr.push(item.id);
            });
            let cfs = await getFormFieldListByIds(idArr.join(','));
            if (cfs && cfs.length > 0) {
                for (var i = 0; i < cfs.length; i++) {
                    if (cfs[i].type === 'subform') {
                        continue;
                    } else {
                        rtArr.push(cfs[i]);
                    }
                }
            }
            this.conditionFields = rtArr;
            this.showConditionFields = true;
            this.loadtimeSearch = new Date().getTime();
            loading.close();
        },
        renderSearchArry () {
            return this.conditionFields;
        }
    }
};
</script>

<style lang="less">
// .search-field-box-new{
//     overflow: hidden !important;
//     height: auto !important;
// }
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/DataWarehousingSearch.vue